module.exports = __webpack_public_path__ + "img/notice.27578fef.png";